import '../wdyr';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { ThemeProvider } from '@material-ui/core';
import './i18n';

import client from 'api/environment';

import BreadcrumbsProvider from 'components/common/Breadcrumbs/BreadcrumbsProvider';
import commonReplace from 'components/common/Breadcrumbs/commonReplace';
import { ToastContainer } from 'components/common/Toast/Toast';
import MutationStateProvider from 'utils/MutationStateProvider';

import { ReactKeycloakProvider } from '@react-keycloak/web';
import Loader from 'common/Loader';
import App from './Routs';
import toastTheme from './themes/toast';
import keycloak, { initOptions } from './keycloak';
import { ConfirmationDialogContainer } from './components/common/ConfirmationDialog/ConfirmationDialog';

const tokenSaver = (tokens) => {
  localStorage.setItem('idToken', tokens.idToken);
  localStorage.setItem('refreshToken', tokens.refreshToken);
  localStorage.setItem('token', tokens.token);
};

const onEvent = (event) => {
  if (event === 'onAuthSuccess') {
    keycloak.loadUserProfile().then((keycloakProfile) => {
      localStorage.setItem('userProfile', JSON.stringify(keycloakProfile));
    });
  }
};

ReactDOM.render(
  <>
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={initOptions}
      onTokens={tokenSaver}
      onEvent={onEvent}
      LoadingComponent={<Loader />}
    >
     <ApolloProvider client={client}>
        <Router basename={process.env.MAIN_PATH}>
          <MutationStateProvider>
            <BreadcrumbsProvider commonReplace={commonReplace}>
              <App />
            </BreadcrumbsProvider>
          </MutationStateProvider>
        </Router>
      </ApolloProvider>
    </ReactKeycloakProvider>
    <ThemeProvider theme={toastTheme}>
      <ToastContainer />
      <ConfirmationDialogContainer />
    </ThemeProvider>
  </>,
  document.getElementById('root')
);
